import { LanguageRecord } from '@/graphql/types'
import { SearchHistoryItem } from '@/hooks/useSearchHistory'
import { cn } from '@desoutter/uikit'

interface SearchHistoryProps {
	searchHistory: SearchHistoryItem[]
	onSearchClick: (query: string) => void
	translations?: Partial<LanguageRecord>
	isModal?: boolean
}

export default function SearchHistory({
	searchHistory,
	onSearchClick,
	translations = {},
	isModal = false,
}: SearchHistoryProps) {
	if (searchHistory.length === 0) {
		return null
	}

	const formatResultCount = (count: number) => {
		if (count === 0) {
			return 'No results'
		}
		return `${count} ${translations.results}`
	}

	// In modal, we display only the last 5 results
	const cropedHistoryResults = isModal
		? searchHistory.slice(0, 5)
		: searchHistory

	return (
		<div className="w-full max-w-lg mx-auto flex flex-col h-full">
			<div className="text-xs text-gray-400 mb-3 px-3 flex-shrink-0">
				{translations.previousSearches || 'Previous searches'}
			</div>
			<div className={cn('flex flex-col gap-2')}>
				{cropedHistoryResults.map((item) => (
					<div
						key={`${item.query}-${item.timestamp}`}
						className="flex items-center justify-between rounded-lg px-3 py-2 hover:bg-gray-50 transition-colors cursor-pointer group text-sm gap-12"
						onClick={() => onSearchClick(item.query)}
					>
						<div className="text-gray-900 truncate">{item.query}</div>
						<div className="text-sm text-gray-400 italic flex-shrink-0">
							{formatResultCount(item.resultCount)}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
